<template>
    <img alt="" height="100%" src="/images/exhibit_group_w.svg" title="Exhibit Group" width="100%" />
</template>
